export default [
  {
    url: 'https://www.costa.co.uk',
    locale: 'x-default',
  },
  {
    url: 'https://www.costa.co.uk',
    locale: 'en-GB',
  },
  {
    url: 'https://www.costacoffee.jp',
    locale: 'ja-JP',
  },
  {
    url: 'https://www.costacoffee.de',
    locale: 'de-DE',
  },
  {
    url: 'https://us.costacoffee.com',
    locale: 'en-US',
  },
  {
    url: 'https://www.costaireland.ie',
    locale: 'en-IE',
  },
  {
    url: 'https://www.costacoffee.ae',
    locale: 'en-AE',
  },
  {
    url: 'https://www.costacoffee.mx',
    locale: 'es-MX',
  },
  {
    url: 'https://www.costa-coffee.be',
    locale: 'nl-BE',
  },
  {
    url: 'https://www.costa-coffee.be/fr',
    locale: 'fr-BE',
  },
  {
    url: 'https://www.costacoffee.no',
    locale: 'nb-NO',
  },
  {
    url: 'https://www.costacoffee.in',
    locale: 'en-IN',
  },
  {
    url: 'https://www.costa-coffee.at',
    locale: 'de-AT',
  },
  {
    url: 'https://www.costacoffee.es',
    locale: 'es-ES',
  },
  {
    url: 'https://www.costacoffee.ro',
    locale: 'ro-RO',
  },
  {
    url: 'https://www.hu.costacoffee.com',
    locale: 'hu-HU',
  },
  {
    url: 'https://www.costacoffee.gr',
    locale: 'el-GR',
  },
  {
    url: 'https://www.costa-coffee.ch',
    locale: 'de-CH',
  },
  {
    url: 'https://www.costa-coffee.ch/fr',
    locale: 'fr-CH',
  },
  {
    url: 'https://www.costa-coffee.ch/en',
    locale: 'en-GB',
  },
  {
    url: 'https://www.costacoffee.si',
    locale: 'sl-SL',
  },
  {
    url: 'https://www.costacoffee.hr',
    locale: 'hr-HR',
  },
  {
    url: 'https://www.cz.costacoffee.com',
    locale: 'cz-CZ',
  },
  {
    url: 'https://www.sk.costacoffee.com',
    locale: 'sk-SK',
  },
  {
    url: 'https://www.costacoffee.eg',
    locale: 'en-GB',
  },
  {
    url: 'https://www.costacoffee.eg/ar',
    locale: 'ar-EG',
  },
  {
    url: 'https://www.bg.costacoffee.com',
    locale: 'bg-BG',
  },
  {
    url: 'https://www.costa-coffee.rs',
    locale: 'sr-Cyrl-BA',
  },
  {
    url: 'https://www.us.costacoffee.com',
    locale: 'en-US',
  },
  {
    url: 'https://www.costacoffee.mt',
    locale: 'en-MT',
  },
  {
    url: 'https://www.costacoffee.pk',
    locale: 'en-PK',
  },
  {
    url: 'https://www.costacoffee.pl',
    locale: 'pl-PL',
  },
]
